import React from 'react';
import { View ,Image , StyleSheet,BackHandler,Dimensions } from 'react-native';
import AsyncStorage from '@react-native-community/async-storage';
import { TextInput, Button ,IconButton, Text,Snackbar} from 'react-native-paper';
import CountDown from 'react-native-countdown-component';

const theme = {
  colors: {
    primary: '#2ebbc4',
    accent: '#2ebbc4',
    text:'#3a3635'
  },
};

const viewH= Dimensions.get('window').height*0.6;

const onBackPress = () => { return true };

export default class App extends React.Component {

    state={
        vcode: '',
        buttonDisabled : false,
        toastVisible: false,
        resend:false,
        connectionToast: false,
        error1:'کد فعالسازی صحیح نمیباشد'
      };

      componentDidMount(){
        this._unsubscribe = this.props.navigation.addListener('focus', () => {
          BackHandler.addEventListener('hardwareBackPress', onBackPress);
        });
      }

      componentWillUnmount() {
        BackHandler.removeEventListener('hardwareBackPress', onBackPress);
        this._unsubscribe();
      }

  render() {
    return (
        <View style={{ backgroundColor:'white' ,flex:1,justifyContent:'center',alignItems:'center'}}>
          
          <View style={{flex:1,justifyContent:'space-between',alignItems:'center',width:'100%', maxHeight:viewH,marginBottom:20}}>
          <Image style={{marginLeft:'auto',marginRight:'auto',width:150, height:30 }} resizeMode='contain' source={require('../assets/img/logotype.png')}/>
          
          <Text style={{width:'65%', fontSize: 12,marginTop:30}}>لطفا کد فعالسازی ارسال شده به شماره {global.mobile} را وارد کنید. <Text 
          style={{color:'#2ebbc4'}}
          onPress={()=> this.props.navigation.navigate('Login')}
          >تغییر شماره</Text></Text>

          <View style={{width:'100%',marginVertical:30}}>
          
          <TextInput
              style={styles.inputContainerStyle}
              label="کد فعالسازی"
              value={this.state.vcode}
              onChangeText={vcode => this.setState({ vcode })}
              keyboardType="numeric"
              maxLength={6}
              theme= {theme}
              selectionColor='#c4fbff'
            />
            <View style={{flexDirection:'row',marginLeft:'auto',marginRight:'auto',marginTop:10}}>
              <Text style={{fontSize:11, marginHorizontal:5}}>ارسال مجدد کد</Text>
              {!this.state.resend ? 
                          <CountDown
                          until={121}
                          onFinish={() => this.setState({resend:true})}
                          timeToShow={['M','S']}
                          timeLabelStyle={{display:'none'}}
                          digitStyle={{backgroundColor: '#FFF'}}
                          digitTxtStyle={{color: '#000',fontWeight:'normal',fontSize:11}}
                          showSeparator
                          separatorStyle={{color: '#000',fontWeight:'normal',fontSize:11}}
                          /> :
                          <IconButton
                          icon="refresh"
                          size={15}
                          style={{margin:0,marginTop:-3}}
                          onPress={() => {
                            this.setState({resend:false})
                              fetch('https://fitwayz.ir/api/auth/register',
                              {
                                method:'POST',
                                headers: {
                                  Accept: 'application/json',
                                  'Content-Type': 'application/json',
                                },
                                body: JSON.stringify({
                                  mobile : global.mobile,
                                  fname : 'Unverified User',
                                  lname : 'Unverified User',
                                  gender : 0,
                                  image : null,
                                })
                              }).then(response => response.json()).then(responseJson => {
                                   if (responseJson.result == 'success'){
                                    console.log(responseJson);
                                   } else{
                                     fetch('https://fitwayz.ir/api/auth/password/reset',
                                     {
                                       method:'POST',
                                       headers: {
                                         Accept: 'application/json',
                                         'Content-Type': 'application/json',
                                       },
                                       body: JSON.stringify({
                                         mobile : global.mobile
                                       })
                                     }).then(response1 => response1.json()).then(responseJson1 => {
                                       console.log(responseJson1);
                                       if (responseJson1.result == 'success'){
                                        console.log('Hi')
                                        console.log(responseJson1)
                                       } else {
                                         console.log(responseJson1)
                                       }
                                     })
                                     .catch(error => {
                                       console.log('here')
                                       console.log(error)
                                     });
                                   }
                                   })
                                   .catch(error => {
                                     console.log(error)
                                   });
                          }
                         } 
                          />
                          }

            </View>
            </View>


 


            <Button mode='contained' dark={true} style={styles.button} color='#2ebbc4' theme= {theme} disabled={this.state.buttonDisabled} loading={this.state.buttonDisabled}
             onPress={() => {
              this.setState({buttonDisabled: true});
              fetch('https://fitwayz.ir/api/auth/login',
              {
                method:'POST',
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  mobile : global.mobile,
                  password : this.state.vcode,
                  version : 2
                })
              })
              .then(response => response.json()).then(responseJson => {
                if(responseJson.result == 'success'){
                  if(responseJson.user.fname == 'Unverified User'){
                    global.token = responseJson.token;
                    global.password = this.state.vcode;
                    this.props.navigation.navigate('Register');
                  }else{
                  global.token = responseJson.token;
                  global.fname = responseJson.user.fname;
                  global.lname = responseJson.user.lname;
                  global.gender =  responseJson.user.gender == 'مرد' ? 0 : 1;
                  global.image.uri = responseJson.user.image.replace('http','https');
                  let userData = {mobile :responseJson.user.mobile , pass : this.state.vcode };
                  AsyncStorage.setItem('@auths', JSON.stringify(userData));

                  fetch('https://fitwayz.ir/api/users/info',
                  {
                    method:'POST',
                    headers: {
                      Accept: 'application/json',
                      Authorization: 'Bearer ' + global.token,
                      'Content-Type': 'application/json',
                    },
                    body: JSON.stringify([])
                  })
                  .then(response1 => response1.json()).then(responseJson1 => {
                    console.log(responseJson1);
                    global.credit=responseJson1.credit;
                    this.props.changeAppState('Main')
                  })
                  .catch(error => {
                    console.log(error)
                    this.setState({buttonDisabled: false,connectionToast:true});
                  });
                }
                } else{
                  console.log(responseJson)
                  let myError ='';
                  if(responseJson.result == 'error'){
                    myError=responseJson.messages[0];
                  }else{
                    myError=responseJson.error;
                  }
                  this.setState({ toastVisible: true ,buttonDisabled: false,error1:myError});
                }
              })
              .catch(error => {
                this.setState({buttonDisabled: false,connectionToast:true});
              });
             }
            } 
            contentStyle={{width:170,height:46}}>ادامه</Button>
          
        </View> 

        <Snackbar
        style={{zIndex:200}}
          visible={this.state.toastVisible}
          onDismiss={() => this.setState({ toastVisible: false })}>
  {this.state.error1}
        </Snackbar>

        <Snackbar
          style={{zIndex:200}}
          visible={this.state.connectionToast}
          onDismiss={() => this.setState({ connectionToast: false })}>
         ارتباط اینترنت با مشکل مواجه است
        </Snackbar>

        </View>
    );
  }
}

const styles = StyleSheet.create({
    inputContainerStyle: {
      marginLeft: 'auto',
      marginRight:'auto',
      width: '65%',
      backgroundColor:'white',
    },
    button:{
      marginLeft:'auto',
      marginRight:'auto',
      borderRadius:23,

    },

  });
  
